// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_report_report_module_ts":"a4471c75ebfa2f3c","src_app_features_arc_arc_module_ts":"bc3abead4980b57f"}[chunkId] + ".js";
};